import { render, staticRenderFns } from "./role-menu-manage.vue?vue&type=template&id=3810056e&scoped=true&"
import script from "./role-menu-manage.vue?vue&type=script&lang=js&"
export * from "./role-menu-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810056e",
  null
  
)

export default component.exports